// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7ecd68d1","455":"53fc2741"}[chunkId] + ".chunk.js";
};